import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unity',
  templateUrl: './unity.component.html',
  styleUrls: ['./unity.component.css']
})
export class UnityComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
